import { computed, toValue } from "vue";
import type { ComputedRef, MaybeRefOrGetter } from "vue";
import { useStore } from "vuex";
import { isDefined } from "@utils/var.check";

interface ProcessingState {
  getProcessingTriggerElement: ComputedRef<string | undefined>;
  isProcessing: ComputedRef<boolean>;
  setProcessing: (triggerElement?: string) => void;
  resetProcessing: () => void;
}

export function useProcessingState(
  processingId?: MaybeRefOrGetter<string | undefined>,
): ProcessingState {
  const store = useStore();

  const defaultProcessingId = computed(() => toValue(processingId) || "");

  const getProcessingTriggerElement = computed(() => {
    return store.getters["app/getProcessingState"](defaultProcessingId.value);
  });

  const isProcessing = computed(() => {
    return isDefined(getProcessingTriggerElement.value);
  });

  const setProcessing = (triggerElement?: string) => {
    store.dispatch("app/setProcessingState", {
      id: defaultProcessingId.value,
      triggerElement: triggerElement,
    });
  };

  const resetProcessing = () => {
    store.dispatch("app/removeProcessingState", defaultProcessingId.value);
  };

  return {
    getProcessingTriggerElement,
    isProcessing,
    setProcessing,
    resetProcessing,
  };
}
